import { useState, useEffect } from "react";
import { sendNotificationCongrats, sendDirectCongrats } from "../../utils/API/interaction";
import { useNotifications } from "../../utils/NotificationContext";
import { LogOut } from "../../utils/API/auth";
import "./styles.css";

const SendCongratsButton = ({ notificationId, userId, onCongratsSent, initialCongratsSent = false }) => {
  const [congratsSent, setCongratsSent] = useState(initialCongratsSent);
  const { addNotification } = useNotifications();

  useEffect(() => {
    setCongratsSent(initialCongratsSent);
  }, [initialCongratsSent]);

  const handleCongratsSent = async () => {
    if (congratsSent) return;
    
    setCongratsSent(true);

    let sendResult;
    if (notificationId) {
      sendResult = await sendNotificationCongrats(notificationId);
    } else if (userId) {
      sendResult = await sendDirectCongrats(userId);
    } else {
      addNotification("Error: No target specified for congratulations");
      return;
    }

    if (sendResult.code === 200) {
      if (onCongratsSent) {
        onCongratsSent();
      }
    } else if (sendResult.code === 400) {
      setCongratsSent(false);
      addNotification(sendResult.message);
    } else if (sendResult.code === 403) {
      LogOut();
      addNotification("Please log in once again.");
      navigator("/");
      return;
    } else if (sendResult.code === 500) {
      setCongratsSent(false);
      addNotification(sendResult.message);
    } else {
      setCongratsSent(false);
      addNotification(sendResult.message);
    }
  };

  return (
    <div className="interaction" onClick={handleCongratsSent}>
      <span style={{ color: congratsSent ? '#00FFC2' : 'inherit' }}>
        {congratsSent ? "Congrats sent!" : "Send congrats!"}{" "}
      </span>
      <img src="/assets/images/confetti.png" alt="" />
    </div>
  );
};

export default SendCongratsButton; 